// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  enableDebug: true,

  numero_WhatsApp: "",
  numero_telefono: "tel:+390961754019",

  //text per personalizzare i messaggi
  canShowPagamentoRate: false,
  textShowPagamentoRate: "in comode <strong>2 rate</strong>",

  canShowElencoDate: true,

  /*
  urlWeb: 'http://localhost/',
  urlMaterialeDidattico: 'http://localhost/assets/media/materiale-didattico/1/',
  urlImageCorso: 'http://localhost/assets/media/corso/',
  urlImageCorsoHD: 'http://localhost/assets/media/corso/hd/',
  urlImageVideoCorso: 'http://localhost/assets/media/corso/video/',
  web_api_url_base: 'http://localhost/api/',

  urlStampa: 'http://localhost/stampe/',

  urlAttestati: 'http://localhost/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'http://localhost/pages/certificate/',
  urlImagePartners: 'http://localhost/assets/media/partners/',
  urlImageMedia: 'http://localhost/assets/media/',
  */

  urlWeb: 'https://esisud.discentya.it/',
  urlMaterialeDidattico: 'https://esisud.discentya.it/assets/media/materiale-didattico/1/',
  urlImageCorso: 'https://esisud.discentya.it/assets/media/corso/',
  urlImageCorsoHD: 'https://esisud.discentya.it/assets/media/corso/hd/',
  urlImageVideoCorso: 'https://esisud.discentya.it/assets/media/corso/video/',
  web_api_url_base: 'https://esisud.discentya.it/api/',

  urlStampa: 'https://esisud.discentya.it/stampe/',

  urlAttestati: 'https://esisud.discentya.it/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'https://esisud.discentya.it/pages/certificate/',
  urlImagePartners: 'https://esisud.discentya.it/assets/media/partners/',
  urlImageMedia: 'http://esisud.discentya.it/assets/media/',

};

